import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Permission from '../../../../../classes/common/permission';
import { CommentFlatButton, FavoriteFlatButton, ClaimFlatButton } from '../../../../Controls/index';
import IconEdit from '../../../../Icons/IconEdit';
import IconProfile from '../../../../Icons/IconProfile';

class Controls extends React.Component {
  constructor (props) {
    super(props);

    this.item = this.props.item;
    this.rawItem = this.props.rawItem;
  }

  componentWillReceiveProps (nextProps, nextContext) {
    this.item = nextProps.item;
    this.rawItem = nextProps.rawItem;
  }

  renderControls () {
    const item = this.item;
    const permission = item.getPermissions();
    const author = item.getAuthor();
    const comment = item.getComment();
    const exist = (comment && comment.get('id')) || false;
    const {
      eventAddFavorites,
      eventRemoveFavorites,
      eventOpenCommentForm,
      eventOpenClaimForm,
      eventAddFavoritesForCian,
      eventRemoveFavoritesForCian
    } = this.props;

    return (
      <Fragment>
        <FavoriteFlatButton
          userId={this.props.user.getIn(['data', 'id'], null) || null}
          itemId={item.getProperty().getId()}
          dealType={item.getDealType()}
          realtyType={item.getRealtyType()}
          active={item.isFavorite()}
          eventAddFavorites={eventAddFavorites}
          eventRemoveFavorites={eventRemoveFavorites}
          eventAddFavoritesForCian={() => eventAddFavoritesForCian(this.rawItem)}
          eventRemoveFavoritesForCian={() => eventRemoveFavoritesForCian(this.rawItem)}
        />

        <ClaimFlatButton
          className='hover-visible'
          realtyId={item.getProperty().getId()}
          dealType={item.getDealType()}
          realtyType={item.getRealtyType()}
          eventOpenClaimForm={eventOpenClaimForm}
        />

        <CommentFlatButton
          className={exist ? 'active' : 'hover-visible'}
          comment={comment}
          userId={this.props.user.getIn(['data', 'id'], null) || null}
          realtyId={item.getProperty().getId()}
          dealType={item.getDealType()}
          realtyType={item.getRealtyType()}
          eventOpenCommentForm={eventOpenCommentForm}
        />


        {
          permission.isAllow(Permission.IS_EDIT) &&
          (

            <a
              href={item.getEditLink()}
              onClick={(e) => {
                e.stopPropagation();
              }}
              data-tip
              data-for='tip-edit'
              target='_blank'
              className='hover-visible button'
            >
              <IconEdit />
            </a>
          )
        }

        {
          permission.isAllow(Permission.IS_GO_PROFILE) &&
          (
            <a
              href={author && author.getManageLink()}
              onClick={(e) => {
                e.stopPropagation();
              }}
              data-tip
              data-for='tip-profile'
              target='_blank'
              className='button hover-visible'
            >
              <IconProfile />
            </a>
          )
        }
      </Fragment>
    );
  }

  render () {
    return (
      <div className='property__controls'>
        { this.renderControls() }
      </div>
    );
  }
}

Controls.propTypes = {
  item: PropTypes.object.isRequired,
  rawItem: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,

  eventAddFavorites: PropTypes.func,
  eventRemoveFavorites: PropTypes.func,
  eventOpenCommentForm: PropTypes.func,
  eventOpenClaimForm: PropTypes.func,
  eventAddFavoritesForCian: PropTypes.func,
  eventRemoveFavoritesForCian: PropTypes.func
};

Controls.defaultProps = {
  eventAddFavorites: id => {},
  eventRemoveFavorites: id => {},
  eventOpenCommentForm: id => {},
  eventOpenClaimForm: id => {},
  eventAddFavoritesForCian: id => {},
  eventRemoveFavoritesForCian: id => {}
};

export default Controls;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FlexItems/Items/Controls.jsx